import React from "react";
import styled from "styled-components";
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

export default function TimeLimitInput(props) {
  const { isUseTimeLimit, min, setMin, sec, setSec } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  
  
	function handleClick(e) {
	}

	function handleChangeMin(e) {
    let regex = /[^0-9]/g;				// 숫자가 아닌 문자열을 선택하는 정규식
    let result = e.target.value.replace(regex, "");
    
    if (result === '') setMin(0);
		else setMin(result);
	}

	function handleChangeSec(e) {
    let regex = /[^0-9]/g;				// 숫자가 아닌 문자열을 선택하는 정규식
    let result = e.target.value.replace(regex, "");
    
    if (result === '') setSec(0);
		else setSec(result);
	}


	function handleFocus(e) {
	}

	function handleBlur(e) {
	}
  
  return (
    <TotalInputWrapper>
      <InputWrapper isUseTimeLimit={isUseTimeLimit}>
        <Input
          type='text'
          placeholder={0}
          disabled={!isUseTimeLimit}
          value={isUseTimeLimit ? min : 'MAX'}
          onChange={handleChangeMin} />
      </InputWrapper>
      <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.text}>{t('board.minuteShort')}</Text>
      <InputWrapper isUseTimeLimit={isUseTimeLimit}>
        <Input
          type='text'
          placeholder={0}
          disabled={!isUseTimeLimit}
          value={isUseTimeLimit ? sec : 'MAX'}
          onChange={handleChangeSec}/>
      </InputWrapper>
      <Text fontFamily='Poppins-Medium' fontSize={14} color={theme.text}>{t('board.secondShort')}</Text>
    </TotalInputWrapper>
  )
}


const TotalInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  // padding: 0px 10px;

  // width: calc(100% - 22px);
  width: 100%;
  height: 34px;

  gap: 4px;

  // border: 1px solid #CBCBCB;
  // border-radius: 30px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 10px;

  width: calc(38.75% - 22px);
  height: 34px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 30px;
  background-color: ${props => props.isUseTimeLimit ? props.theme.subBackground : props.theme.line};

  transition: all 0.3s ease-in-out;
`;

const Input = styled.input` 
	font-family: Poppins-Medium;
	font-size: 14px;
	line-height: 20px;
	
  display: flex;
  flex-direction: row;

  width: 100%;

  border: 0px;
  background-color: ${props => props.theme.subBackground};

  color: ${props => props.theme.text};

	outline: none;

	::placeholder {
    font-family: NotoSansKR-Regular;
    font-size: 14px;

		color: ${props => props.theme.line};
	}

  &:disabled {
    color: ${props => props.theme.white};
    background-color: ${props => props.theme.line};
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  &:hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;